import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import Fly from "../../../assets/img/Featured/fly-tap-pay.png";
import OnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import QuickPay from "../../../assets/img/Featured/app-qr-quickpay.png";
import GuestApp from "../../../assets/img/Featured/app-guest-dining.png";
import Reserve from "../../../assets/img/Featured/app-reserve2.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const PoolPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page poolPage">
            <Header />
            <div className="page-header">Hotel</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Poolside Dining</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Delight guests with food and beverage at-a-click
                    ordering delivered wherever they are. Enhance
                    the poolside experience with fast, easy, mobile
                    ordering and payment to drive increased order
                    volume, improve check size and grow F&B
                    revenue.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Pool", "IG Fly");
                    addFlow("IG Fly");
                    navigate("/solutions/ig-fly")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Fly
                    </div>
                    <img src={Fly} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Pool", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    <img src={OnDemand} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Pool", "IG QuickPay");
                    addFlow("IG QuickPay");
                    navigate("/solutions/ig-quick-pay")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG QuickPay
                    </div>
                    <img src={QuickPay} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Pool", "Reserve");
                    addFlow("Reserve");
                    navigate("/solutions/reserve")}}>
                    <div className="item-head">
                        <LogoMini />
                        Reserve
                    </div>
                    <img src={Reserve} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Pool", "Guest App");
                    addFlow("Guest App");
                    navigate("/solutions/guest-app")}}>
                    <div className="item-head">
                        <LogoMini />
                        Guest App
                    </div>
                    <img src={GuestApp} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}

export default PoolPage;